<script>
export default {
	name: 'IconSvgGz',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		width: {
			type: String,
			default: '40',
		},
		height: {
			type: String,
			default: '45',
		},
	},
}
</script>

<template>
	<div>
		<svg :width="width" :height="height" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M13.4781 4.104C13.0134 4.10333 12.5678 3.92198 12.2392 3.5997C11.9107 3.27743 11.7259 2.84055 11.7254 2.3849V0H3.89355C3.28691 0 2.70511 0.236249 2.27615 0.656782C1.84719 1.07731 1.6062 1.64769 1.6062 2.24241V15.7602C1.6071 16.3543 1.84849 16.9238 2.27735 17.3436C2.70621 17.7635 3.28749 17.9993 3.89355 17.9992H13.2954C13.9015 17.9993 14.4827 17.7635 14.9116 17.3436C15.3405 16.9238 15.5818 16.3543 15.5827 15.7602V4.104H13.4781Z"
				:fill="color" />
			<path
				d="M15.5828 4.104H13.4782C13.0134 4.10333 12.5678 3.92198 12.2393 3.5997C11.9107 3.27743 11.7259 2.84055 11.7255 2.3849V0L15.5828 4.104Z"
				fill="#FFBC00" />
			<path
				d="M17.2411 14.2169H6.61266C5.85873 14.2169 5.24756 14.8161 5.24756 15.5552V18.6617C5.24756 19.4008 5.85873 20 6.61266 20H17.2411C17.995 20 18.6062 19.4008 18.6062 18.6617V15.5552C18.6062 14.8161 17.995 14.2169 17.2411 14.2169Z"
				fill="#FFBC00" />
			<path d="M9.84525 17.7863V18.3921H9.2052V17.7863H9.84525Z" fill="#F3F3F6" />
			<path
				d="M13.5205 17.8671H14.6485V18.3562H12.8337V17.8954L13.9438 16.3363H12.8482V15.8505H14.6417V16.3113L13.5205 17.8671Z"
				fill="#F3F3F6" />
			<path
				d="M12.1471 16.0631C12.3491 16.2148 12.4851 16.4382 12.5271 16.6873H11.8854C11.8435 16.5979 11.7756 16.5232 11.6904 16.4731C11.595 16.4164 11.4856 16.3876 11.3746 16.3898C11.2883 16.3863 11.2023 16.4018 11.1227 16.4352C11.043 16.4686 10.9717 16.5191 10.9137 16.5831C10.7918 16.729 10.7299 16.9158 10.7404 17.1056C10.7404 17.344 10.8012 17.527 10.9229 17.6548C10.9913 17.7211 11.0729 17.7725 11.1623 17.8055C11.2517 17.8385 11.347 17.8524 11.4421 17.8465C11.5781 17.8489 11.7111 17.8071 11.8212 17.7273C11.9337 17.6433 12.0149 17.5243 12.0521 17.389H11.2863V16.9531H12.5587V17.5523C12.5098 17.7013 12.4329 17.8396 12.3321 17.9598C12.2224 18.0889 12.0863 18.1929 11.9329 18.2648C11.7594 18.345 11.5699 18.3849 11.3788 18.3815C11.1462 18.3876 10.9162 18.3321 10.7121 18.2206C10.5253 18.1156 10.3733 17.9583 10.2746 17.7681C10.1686 17.5622 10.1156 17.3331 10.1204 17.1015C10.1163 16.8713 10.1692 16.6437 10.2746 16.439C10.3731 16.2492 10.5245 16.092 10.7104 15.9865C10.9115 15.8757 11.1384 15.8202 11.3679 15.8256C11.6469 15.8156 11.9212 15.8992 12.1471 16.0631Z"
				fill="#F3F3F6" />
			<path
				d="M8.5933 12.7095C8.30744 12.7091 8.03343 12.5975 7.83138 12.3993C7.62933 12.201 7.51573 11.9323 7.5155 11.6521V10.5946H9.67195V11.6521C9.67173 11.9324 9.55801 12.2013 9.35577 12.3996C9.15353 12.5978 8.87931 12.7093 8.5933 12.7095ZM8.06715 11.1354V11.6521C8.06715 11.7889 8.12256 11.9202 8.2212 12.0171C8.31985 12.114 8.45368 12.1685 8.5933 12.1687C8.733 12.1685 8.86691 12.114 8.9657 12.0171C9.06448 11.9203 9.12007 11.789 9.1203 11.6521V11.1354H8.06715Z"
				fill="#FFBC00" />
			<path d="M7.51438 10.5955H8.59558V9.5355H7.51438V10.5955Z" fill="#FFBC00" />
			<path d="M8.59324 9.53625H9.67444V8.4763H8.59324V9.53625Z" fill="#FFBC00" />
			<path d="M7.51438 8.47717H8.59558V7.41722H7.51438V8.47717Z" fill="#FFBC00" />
			<path d="M8.59324 7.41797H9.67444V6.35802H8.59324V7.41797Z" fill="#FFBC00" />
		</svg>

	</div>
</template>

<style scoped>

</style>